import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-4 md:px-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((c, idx) => {
            const count = articles.filter((a) => a.category === c.slug).length;
            const tint =
              idx % 3 === 0
                ? "bg-primary-100 text-primary-600"
                : idx % 3 === 1
                  ? "bg-accent-100 text-accent-700"
                  : "bg-secondary-100 text-secondary-700";
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group flex cursor-pointer flex-col gap-2 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${tint}`}>
                  <i className={`${c.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-600">
                  {c.name}
                </h3>
                <p className="line-clamp-2 text-xs leading-5 text-foreground-500">{c.desc}</p>
                <span className="mt-1 flex items-center gap-1 text-xs font-medium text-foreground-500">
                  {count} 条爆料
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}